import { forwardRef } from 'react'
import { Link as RRLink } from 'react-router-dom'

export type AppLinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  'href'
> & {
  href: string
  prefetch?: boolean
  state?: unknown
}

const Link = forwardRef<HTMLAnchorElement, AppLinkProps>(
  ({ href, prefetch: _prefetch, state, ...rest }, ref) => (
    <RRLink ref={ref} to={href} state={state} {...rest} />
  ),
)

Link.displayName = 'Link'

export default Link
